import Spinner from "../components/Spinner";
import useFetch from "../hooks/useFetch";
import Analytics from "../page_components/social_service/analytics";
import SocialServiceCard from "../page_components/social_service/social_service_card";

import { Helmet } from 'react-helmet-async';

const SocialServices = () => {
    return (
        <>
            <Helmet>
                <link rel="stylesheet" href="../../iusevolutione/assets/vendor/css/pages/card-analytics.css" />
            </Helmet>

            <Helmet>
                <script src="../../iusevolutione/assets/js/app-ecommerce-dashboard.js"></script>
            </Helmet>

            <div className="container-xxl flex-grow-1 container-p-y">
                <h4 className="py-3 mb-4"><span className="text-muted fw-light">Analytics</span></h4>

                {/* {isLoading && <Spinner />}
                {errorMessage && <div>{errorMessage}</div>} */}
                {/* <SocialServiceCard/> */}
                <Analytics/>
            </div>

          
        </>
    );
}


export default SocialServices;